"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const subscribable_1 = __importDefault(require("./subscribable"));
const util_1 = require("../services/util");
class PaymentCard extends subscribable_1.default {
    constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = 'paymentCard';
        this._cardId = initParams.card_id;
        this._card = initParams.card;
        this._bacs_debit = initParams.bacs_debit;
    }
    set cardId(value) {
        console.error('Do not set objects this way');
    }
    setCardId(value) {
        return this.dataService.updatePaymentCard(this.id, { card_id: value }, this);
    }
    get cardId() {
        return this._cardId;
    }
    set card(value) {
        console.error('Do not set objects this way');
    }
    setCard(value) {
        return this.dataService.updatePaymentCard(this.id, { card: value }, this);
    }
    get card() {
        return this._card;
    }
    set bacs_debit(value) {
        console.error('Do not set objects this way');
    }
    setBacs_debit(value) {
        return this.dataService.updatePaymentCard(this.id, { bacs_debit: value }, this);
    }
    get bacs_debit() {
        return this._bacs_debit;
    }
    set(object) {
        let updateObject = (0, util_1.snakeObject)(object);
        let self = this;
        return this.dataService.updatePaymentCard(this.id, updateObject, this)
            .then(function (res) {
            Object.keys(object).forEach(function (key) {
                self['_' + key] = object[key];
            });
            return Promise.resolve(res);
        });
    }
    delete() {
        return this.dataService.deletePaymentCard(this.id, this);
    }
}
exports.default = PaymentCard;
//# sourceMappingURL=paymentCard.js.map